import {useState,useEffect} from "react";
import "./mental.css";

export default function MentalMath(){

const [screen,setScreen]=useState("home");

const [ops,setOps]=useState(["+"]);
const [digits,setDigits]=useState(2);
const [mode,setMode]=useState("time");
const [limit,setLimit]=useState(30);
const [count,setCount]=useState(10);

const [question,setQuestion]=useState("");
const [answer,setAnswer]=useState(0);
const [user,setUser]=useState("");
const [solved,setSolved]=useState(0);
const [attempts,setAttempts]=useState(0);
const [timeLeft,setTimeLeft]=useState(0);
const [lock,setLock]=useState(false);   // prevent double submit

function gen(){

let low=Math.pow(10,digits-1);
let high=Math.pow(10,digits)-1;

let a=Math.floor(Math.random()*(high-low+1))+low;
let b=Math.floor(Math.random()*(high-low+1))+low;
let op=ops[Math.floor(Math.random()*ops.length)];

if(op==="/"){
b=Math.floor(Math.random()*9)+1;
a=b*Math.floor(Math.random()*9+1);
}

let ans;
if(op==="+") ans=a+b;
if(op==="-") ans=a-b;
if(op==="*") ans=a*b;
if(op==="/") ans=a/b;

setQuestion(`${a} ${op} ${b}`);
setAnswer(ans);
setLock(false);
}

function start(){

if(!ops.length){ alert("Select operations"); return; }

setSolved(0);
setAttempts(0);
setUser("");
gen();
setScreen("play");

if(mode==="time") setTimeLeft(limit);
}

/* TIMER */

useEffect(()=>{

if(screen==="play" && mode==="time" && timeLeft>0){
const t=setTimeout(()=>setTimeLeft(x=>x-1),1000);
return ()=>clearTimeout(t);
}

if(timeLeft===0 && mode==="time" && screen==="play"){
setScreen("result");
}

},[timeLeft,screen,mode]);

/* AUTO SUBMIT */

useEffect(()=>{

if(screen==="play" && user!=="" && parseInt(user)===answer && !lock){
submit();
}

},[user]);

function submit(){

if(lock || user==="") return;
setLock(true);

setAttempts(a=>a+1);

if(parseInt(user)===answer){
setSolved(s=>s+1);
}

setUser("");

setTimeout(()=>{

if(mode==="count"){
if(attempts+1>=count){
setScreen("result");
}else gen();
}else gen();

},200);
}

/* HOME */

if(screen==="home") return(

<div className="mental-app">
<div className="card">

<h2>Mental Math Trainer</h2>

<div className="field">
<label>Operations</label>
<select multiple onChange={e=>setOps([...e.target.selectedOptions].map(o=>o.value))}>
<option value="+">Addition</option>
<option value="-">Subtraction</option>
<option value="*">Multiply</option>
<option value="/">Divide</option>
</select>
</div>

<div className="field">
<label>Digits</label>
<input type="number" min="1" max="3"
value={digits}
onChange={e=>setDigits(+e.target.value)}/>
</div>

<div className="field">
<label>Mode</label>
<select value={mode} onChange={e=>setMode(e.target.value)}>
<option value="time">Time Mode</option>
<option value="count">Question Mode</option>
</select>
</div>

{mode==="time" &&
<div className="field">
<label>Seconds</label>
<input type="number" value={limit}
onChange={e=>setLimit(+e.target.value)}/>
</div>
}

{mode==="count" &&
<div className="field">
<label>Questions</label>
<input type="number" value={count}
onChange={e=>setCount(+e.target.value)}/>
</div>
}

<button onClick={start}>Start Training</button>

</div>
</div>
);

/* PLAY */

if(screen==="play") return(

<div className="mental-app">
<div className="card play">

<h1>{question}</h1>

{mode==="time" && <h3>⏱ {timeLeft}s</h3>}
{mode==="count" && <h3>{attempts}/{count}</h3>}

<input
type="number"
placeholder="Your answer"
value={user}
onChange={e=>setUser(e.target.value)}
/>


<button onClick={()=>setScreen("result")}>Quit</button>

</div>
</div>
);

/* RESULT */

const accuracy = attempts ? Math.round((solved/attempts)*100) : 0;

return(

<div className="mental-app">
<div className="card result">

<h2>Session Complete</h2>

<p>Total: {attempts}</p>
<p>Correct: {solved}</p>
<p>Accuracy: {accuracy}%</p>

<button onClick={()=>setScreen("home")}>Train Again</button>

</div>
</div>
);
}
